import React, { FC } from 'react';
import classNames from 'classnames';

import { Destination } from './interfaces/destination.interface';
import { getDomainFromUrl } from 'src/utils/url';
import nodeLogos from 'src/utils/nodeLogos';
import { Nullable } from 'src/types/nullable.type';
import { AttachmentRegularIcon, AttachmentStrongIcon } from 'src/monet/icons';

interface DestinationLogoProps {
  destination?: Nullable<Destination>;
  externalLinkUrl?: Nullable<string>;
  showDefault?: boolean;
  size?: 'small' | 'large';
}

export const DestinationLogo: FC<DestinationLogoProps> = ({ destination, externalLinkUrl, size = 'large' }) => {
  const embedDestinationHost = destination?.host;
  const embedDestinationLogoUrl = destination?.logo_url;

  const embedHost = embedDestinationHost || externalLinkUrl;

  const getWrapperClasses = (hasBackground = true) => {
    return classNames(
      'flex flex-shrink-0 items-center justify-center min-w-0 relative rounded-md text-bedrock-brand-text', {
      'bg-bedrock-brand-primary': hasBackground,
      'w-10 h-10': size === 'large',
      'w-5 h-5': size === 'small',
    }
    )
  }

  if (embedHost) {
    const host = getDomainFromUrl(embedHost).replace('www.', '');
    const vendor = host.split('.')[0];
    // @ts-ignore
    const HostLogo = nodeLogos[host] || nodeLogos[embedHost] || nodeLogos[vendor] || null;

    if (HostLogo) {
      return <HostLogo className={getWrapperClasses(false)} />;
    }

    if (embedDestinationLogoUrl) {
      return <div className={getWrapperClasses(false)}><img src={embedDestinationLogoUrl} className="rounded-md" alt={destination.name} /></div>;
    }
  }

  if (size === 'large') {
    return (
      <div className={getWrapperClasses(true)}>
        <AttachmentRegularIcon />
      </div>
    )
  } else {
    return <AttachmentStrongIcon className='w-5 h-5' />
  }
}